// extracted by mini-css-extract-plugin
module.exports = {"layout":"landing_layout__3vT5s"};